<h3>Uygulama dili</h3>
<div id="uygulamadili">
  <form  action="/dil">
    <label for="sec">Lütfen uygulama dilini seçiniz</label>
    <br><br>
    <select id="sec" name="sec">
      <option value="tr">Türkçe</option>
      <option value="ar">Arapça</option>
      <option value="az">Azeri</option>
      <option value="en">İngilizce</option>
      <option value="de">Almanca</option>
    </select>
    <br><br>
    <input type="submit" value="Gönder">
  </form>
</div>
